import { createModel } from "hox";
import { useState, useEffect } from "react";
import { message } from 'antd'
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { fieldSetService } from "./FieldSetService";
import { dictService } from "@/views/base/dict/dictService";
import { intentionService } from '@/views/join/intention/intentionService'
import { IFieldSetupColumnInsert, IFieldSetupColumnUpdate, IFieldSetupColumnDetail } from "./FieldSetTypes"
import type { DataNode } from 'antd/es/tree';

export const fieldSetModel = createModel(function () {
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
  const { sourceApp, branch } = defaultMdCmParam;

  const [settleTreeData, setSettleTreeData] = useState<DataNode[]>([]);
  const [selectedSettle, setSelectedSettle] = useState<any>();

  const [franchiseeTreeData, setFranchiseeTreeData] = useState<DataNode[]>([]);
  const [selectedFranchisee, setSelectedFranchisee] = useState<any>();
  //字段配置列表
  const [fieldList, setFieldList] = useState<IFieldSetupColumnDetail[]>([])

  //表格选中行Key值
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [selectedData, setSelectedData] = useState<IFieldSetupColumnDetail[]>([]);

  // useEffect(() => {
  //   getSettleDict();
  //   getFranchisee();
  // }, [])

  useEffect(() => {
    if (selectedSettle != null && selectedFranchisee != null) {
      loadFieldSet(selectedSettle.code, selectedFranchisee.code);
    }
  }, [selectedSettle, selectedFranchisee])

  const getSettleDict = async () => {
    let data = {
      sourceApp, branch, "code": "franchisee-settle"
    };
    let { retData } = await dictService.page(data);
    const nodes: DataNode[] = retData[0]?.children.map(item => {
      return { title: item.name, key: item.code, code: item.code }
    })
    setSettleTreeData(nodes);
  }

  const getFranchisee = async () => {
    const searchParams = {
      searchItem: { status: ["franchisee-status.initiated", "franchisee-status.completed", "franchisee-status.received"] },
      pageSize: -1,
      pageNum: 0,
      orders: [{ column: 'createTime', rule: 'DESC' }],
    }
    let { retData } = await intentionService.page(searchParams)
    const { list } = retData
    const nodes: DataNode[] = list.map(item => {
      return { title: item.name, key: item.id, code: item.code }
    })
    setFranchiseeTreeData(nodes);
  }

  const loadFieldSet = (settleCode: string, franchiseeCode: string) => {
    const searchParams = {
      searchItem: { "specialSettlement": settleCode, "franchiseeCode": franchiseeCode },
      pageSize: -1,
      pageNum: 0,
      orders: [{ column: 'createTime', rule: 'DESC' }],
    }
    fieldSetService.page(searchParams).then((res) => {
      const { list } = res.retData
      setFieldList(list)
    })
  }

  const handleInsertField = () => {
    const defaultColumns: IFieldSetupColumnInsert = {
      specialSettlement: selectedSettle.code,
      franchiseeCode: selectedFranchisee.code,
      name: "字段名称",
      isCommon: "0",
      isNull: "0",
      isCount: "0",
      fieldValue: "",
      calculationFormula: "",
      identification: "",
      arrange: ""
    }
    fieldSetService.insert(defaultColumns).then((res) => {
      loadFieldSet(selectedSettle.code, selectedFranchisee.code);
    })
  }

  const handleUpdateField = (data: IFieldSetupColumnUpdate) => {
    fieldSetService.update(data).then((res) => {
      loadFieldSet(selectedSettle.code, selectedFranchisee.code);
    })
  }

  const handleDeleteField = (id: string) => {
    fieldSetService.delete(id).then((res) => {
      loadFieldSet(selectedSettle.code, selectedFranchisee.code);
    })
  }

  const handleInsertBatchFields = () => {
    fieldSetService.insertBatch(selectedData).then((res) => {
      if (res.retData) {
        message.success('操作成功！')
      } else {
        message.error('操作失败')
      }
      loadFieldSet(selectedSettle.code, selectedFranchisee.code);
    })
  }


  return {
    initPgCfg,
    settleTreeData, setSettleTreeData,
    selectedSettle, setSelectedSettle,
    franchiseeTreeData, setFranchiseeTreeData,
    selectedFranchisee, setSelectedFranchisee,
    fieldList, setFieldList,
    handleInsertField, handleUpdateField,
    handleDeleteField, handleInsertBatchFields,
    selectedRowKeys, setSelectedRowKeys,
    selectedData, setSelectedData,
    getSettleDict, getFranchisee
  }

});